<template>
    <div class="box">
        <!-- 产品详情信息 -->
        <el-row class="product-detail" type="flex" justify="center" align="center">
            <!-- 顶部大图 -->
            <el-col :offset="3" :span="18" class="produt-top">
                <div class="detail-left-img">
                    <pic-zoom :previewImg="pruduct.commodityurl"></pic-zoom>
                    <div class="details-minutia">
                        <div class="showpage" @click="move('right')">
                            <i class="el-icon-arrow-left"></i>
                        </div>
                        <ul class="imglist-out">
                            <p id='sumbox' class="imglist-in" style="left:0"
                                :style="{width: comCarousel.length*86 + 'px'}">
                                <span :class="item.class" v-for="(item, index) in comCarousel" :key="index"
                                    class="imglist-item">
                                    <img :src="item.url" @mouseenter="enter(index)">
                                </span>
                            </p>
                        </ul>
                        <div class="showpage" @click="move('left')">
                            <i class="el-icon-arrow-right"></i>
                        </div>
                    </div>
                </div>
                <div class="detail-right">
                    <h3>{{ pruduct.commodityname }}</h3>
                    <p class="type-money" v-if="spec.specprice">Price: ${{ spec.specprice }}
                    </p>
                    <div class="type-text">
                        <!-- 规格材质 -->
                        <p><img src="@/assets/image/icon_yes.png">Specification Material:{{ spec.specstand }}
                        </p>
                        <!-- 等级价格 -->
                        <p><img src="@/assets/image/icon_yes.png">EXW Price:${{ spec.specprice }}
                        </p>
                        <!-- 促销价格 -->
                        <p><img src="@/assets/image/icon_yes.png">Local stock Price:${{ spec.specprom }}
                        </p>
                        <!-- 起订量 -->
                        <p><img src="@/assets/image/icon_yes.png">Minimum Order Quantity:{{ spec.specnum }}
                        </p>
                        <!-- 有库存货期 -->
                        <p><img src="@/assets/image/icon_yes.png">Delivery Time With Stock:{{ spec.specsurvi }}
                        </p>
                        <!-- 无库存货期 -->
                        <p><img src="@/assets/image/icon_yes.png">No Stock Delivery Time:{{ spec.specstock }}
                        </p>
                    </div>
                </div>
            </el-col>
        </el-row>
        <!-- 底部技术细节 -->
        <div class="technicalDetails">
            <el-row :gutter="10" type="flex" justify="center" align="center">
                <el-col :offset="3" :span="18">
                    <p class="item-tit">Technical details</p>
                    <div class="detail-contant">
                        <div class="table">
                            <div class="table-row">
                                <div class="table-cell">
                                    <!-- 重量 -->
                                    <span class="cell-black">Weight</span><br />
                                    <span class="cell-gray">{{spec.speclweight||'--'}} kg</span>
                                </div>
                                <div class="table-cell">
                                    <!-- 口径 -->
                                    <span class="cell-black">DN size</span><br />
                                    <span class="cell-gray">{{spec.specidcaliber||'--'}}</span>
                                </div>
                                <div class="table-cell">
                                    <!-- 外形尺寸 -->
                                    <span class="cell-black">Dimensions</span><br />
                                    <span class="cell-gray">{{spec.specsize||'--'}}</span>
                                </div>
                                <div class="table-cell" v-for="(item,index) in technology" :key="index">
                                    <span class="cell-black">{{item.hfSerchitem.name}}</span><br />
                                    <span class="cell-gray">{{item.typeVal}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <!-- 详情介绍 -->
        <el-row class="detailed-bottom" :gutter="10" type="flex" justify="center" align="center">
            <el-col :offset="3" :span="18" class="detailed-description">
                <p class="item-tit">Detailed Description</p>
                <div class="pro-detail" v-html="pruduct.commoditydetail"></div>
            </el-col>
        </el-row>
        <!-- 技术资料 -->
        <el-row class="documentation" :gutter="10" type="flex" justify="center" align="center">
            <el-col :offset="3" :span="18">
                <p class="item-tit">Documentation</p>
                <el-row class="documentation-word">
                    <el-col class="documentation-word-center" :span="12" v-for="(item,index) in docList" :key="index">
                        <img src="@/assets/image/icon_word.png" v-if="item.type=='doc'||item.type=='docx'" />
                        <img src="@/assets/image/icon_pdf.png" v-if="item.type=='pdf'" />
                        <span><a :href="item.url">{{item.name}}</a></span>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
        <!-- 相关推荐 -->
        <el-row class="product-recommendations" :gutter="10" type="flex" justify="center" align="center">
            <el-col :offset="3" :span="18">
                <p class="item-tit">Products Recommended</p>
                <el-row type="flex" justify="left" align="center" class="recommendations-contant">
                    <el-col :xs="24" :sm="16" :md="12" :lg="8" :xl="6" class="list_box"
                        v-for="(item, index) in relatedList" :key="index">
                        <div class="list_img_box">
                            <el-image class="list_img" :src="item.commodityurl" />
                            <div class="list_title">
                                <p class="type-title">
                                    {{ item.commodityname }}
                                </p>
                                <p class="type-number">Price:$ {{ item.comSpec[0].specprice }}</p>
                            </div>
                            <div class="list_title-else">
                                <p class="type-title-else">Weight(kg)</p>
                                <p class="type-number">{{ item.comSpec[0].speclweight||'--' }}</p>
                            </div>
                            <div class="list_title-else">
                                <p class="type-title-else">DN size</p>
                                <p class="type-number">{{ item.comSpec[0].specidcaliber||'--' }}</p>
                            </div>
                            <div class="list_title-else">
                                <p class="type-title-else">Dimensions</p>
                                <p class="type-number">{{ item.comSpec[0].specsize||'--' }}</p>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import {getCommodityInfo} from "../../api/product/product";
    import PicZoom from "@/components/PicZoom.vue";
    export default {
        components: {
            PicZoom
        },
        data() {
            return {
                commodityid:'',
                moveindex: 0,
                pruduct: {
                    // commodityurl: "https://img2.baidu.com/it/u=2865016181,3960112762&fm=253&fmt=auto&app=138&f=JPEG", //主图
                    // commodityname: "HQ30/44 Brazed plate heat exchanger",
                    // commoditydetail: '<p>&radic;Items&nbsp;that&nbsp;can&nbsp;be&nbsp;purchased&nbsp;online&nbsp;can&nbsp;be&nbsp;added&nbsp;directly&nbsp;to&nbsp;the&nbsp;shopping&nbsp;cart&nbsp;for&nbsp;settlement;</p>↵<p>&radic;Prices&nbsp;include&nbsp;local&nbsp;logistics&nbsp;charges;</p>↵<p>&radic;The&nbsp;heat&nbsp;exchange&nbsp;capability&nbsp;depends&nbsp;on&nbsp;the&nbsp;actual&nbsp;application&nbsp;scenario;</p>↵<p>&radic;The&nbsp;heat&nbsp;exchanger&nbsp;should&nbsp;be&nbsp;maintained&nbsp;and&nbsp;cleaned&nbsp;regularly&nbsp;during&nbsp;operation&nbsp;to&nbsp;avoid&nbsp;affecting&nbsp;the&nbsp;heat&nbsp;exchange&nbsp;effect&nbsp;due&nbsp;to&nbsp;particle&nbsp;deposition;</p>↵<p>&radic;If&nbsp;you&nbsp;need&nbsp;customized&nbsp;equipment,&nbsp;please&nbsp;contact&nbsp;our&nbsp;customer&nbsp;service&nbsp;staff;</p>↵<p>&radic;If&nbsp;you&nbsp;need&nbsp;on-site&nbsp;after-sales&nbsp;service,&nbsp;please&nbsp;contact&nbsp;our&nbsp;customer&nbsp;service&nbsp;staff;</p>'
                },
                spec: {
                    // specprice: 105,
                    // specstand: "SS316",
                    // specprom: 63,
                    // specnum: 3,
                    // specsurvi: 20,
                    // specstock: 15,
                    // speclweight: 69,
                    // specidcaliber: 16,
                    // specsize: 69
                },
                comCarousel: [
                    // {
                    //     url: "https://img0.baidu.com/it/u=3378654313,3962062126&fm=253&fmt=auto&app=138&f=JPEG"
                    // },
                    // {
                    //     url: "https://img0.baidu.com/it/u=978797146,474429034&fm=253&fmt=auto&app=138&f=JPEG"
                    // },
                    // {
                    //     url: "https://img0.baidu.com/it/u=3250855261,2188187986&fm=253&fmt=auto&app=138&f=JPEG"
                    // },
                    // {
                    //     url: "https://img1.baidu.com/it/u=4039792810,85825526&fm=253&fmt=auto&app=138&f=JPEG"
                    // },
                    // {
                    //     url: "https://img1.baidu.com/it/u=110527306,1342718878&fm=253&fmt=auto&app=138&f=JPEG"
                    // }
                ], //缩略图
                technology: [
                    // {
                    //     hfSerchitem: {
                    //         name: "制冷量"
                    //     },
                    //     typeVal: 152
                    // },
                    // {
                    //     hfSerchitem: {
                    //         name: "流量"
                    //     },
                    //     typeVal: 222
                    // },
                    // {
                    //     hfSerchitem: {
                    //         name: "换热量(KBTU/H)"
                    //     },
                    //     typeVal: 3265
                    // },
                    // {
                    //     hfSerchitem: {
                    //         name: "冷热温度"
                    //     },
                    //     typeVal: 65
                    // }
                ],
                docList: [
                    // {
                    //     type: "pdf",
                    //     name: "1665308231263.pdf"
                    // },
                    // {
                    //     type: "doc",
                    //     name: "166530eghd545454.doc"
                    // }
                ],
                relatedList: [
                //     {
                //     commodityurl: "https://img0.baidu.com/it/u=978797146,474429034&fm=253&fmt=auto&app=138&f=JPEG",
                //     commodityname: 'ghGHeghjs Jldkh jsh598-854',
                //     comSpec: [{
                //         specprice: 106,
                //         speclweight: 6354,
                //         specidcaliber: 265,
                //         specsize: 365
                //     }]
                // }
                ]
            };
        },

        methods: {
            //鼠标经过小图
            enter(index) {
                this.pruduct.commodityurl = this.comCarousel[index].url
                for (var i = 0; i < this.comCarousel.length; i++) {
                    this.comCarousel[i].class = "border-grey"
                }
                this.comCarousel[index].class = "border-red"
            },
            move(derect) {
                var _length = this.comCarousel.length
                if (_length > 4) {
                    var _maxNum = _length - 4; //每屏显示几个
                    if (derect == 'left') {
                        this.moveindex++;
                        if (this.moveindex >= _maxNum) {
                            this.moveindex = _maxNum;
                        }
                        this.sumListMove();
                    };
                    if (derect == 'right') {
                        this.moveindex--;
                        if (this.moveindex <= 0) {
                            this.moveindex = 0;
                        }
                        this.sumListMove();
                    };
                }
            },
            sumListMove() {
                var _index = 0;
                var _leftmove = -this.moveindex * (86); //每个图片的宽度
                var _sumbox = document.getElementById('sumbox')
                _sumbox.style.left = _leftmove + "px"
            },
            getDetail(){
                getCommodityInfo({commodityid:this.commodityid}).then((res) => {
                    console.log("商品详情", res);
                    this.pruduct = res.data.comCommodity; //商品详情
                    document.title = this.pruduct.commodityname + ' - HFM'
                    this.relatedList = res.data.comCommodityVO; //推荐列表
                    this.docList = res.data.accessoryList; //文档列表
                    this.technology = res.data.hfCommoditySearchitems;
                    this.pruduct.comSpec.forEach((item) => {
                        if (item.specdefault == 1) {
                            this.spec = item; //规格数据取默认
                        }
                    });
                    if (res.data.comCommodity.comCarousel) {
                        res.data.comCommodity.comCarousel.forEach(item => {
                            this.comCarousel.push({
                                url: item.carouselurl,
                                class: 'border-grey'
                            }) //轮播图
                        })
                    }
                    if (res.data.comRepertoryVOS.length > 0) {
                        this.comrepositorynum = res.data.comRepertoryVOS[0].comrepositorynum //库存量
                        this.repertoryid = res.data.comRepertoryVOS[0].repertoryid //仓库id
                    }
                }).catch((err) => {
                    this.msgError(err.message);
                });
            }
        },

        created() {
            this.commodityid=this.$route.query.id
            this.getDetail()
        },
    };

</script>

<style lang="scss" scoped>
    .box {
        color: #000;
    }

    /* 详情部分 */
    .produt-top {
        display: flex;
    }

    .product-detail {
        background: white;
        padding-top: 40px;
        padding-bottom: 30px;
    }

    .detail-left-img {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .details-minutia {
        width: 380px;
        margin-top: 20px;
        height: 77px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        overflow: hidden;
    }

    .imglist-out {
        overflow: hidden;
        height: 77px;
        position: relative;
        flex: 1;
    }

    .imglist-in {
        position: absolute;
        top: 0;
        animation: mymove 5s infinite;
        -webkit-animation: mymove 5s infinite;
    }

    .imglist-item {
        float: left;
        margin-left: 9px;
        width: 75px;
        height: 75px;
        overflow: hidden;
        white-space: nowrap;
        display: inline;
        position: relative;
    }

    .imglist-item img {
        width: 75px;
        height: 75px;
    }

    .showpage {
        width: 15px;
        height: 77px;
        line-height: 77px;
        text-align: center;
        font-size: 18px;
        color: #999;
        cursor: pointer;
        z-index: 999;
        background: #eee;
    }

    .border-red {
        border: 1px solid rgb(247, 99, 99);
    }

    .border-grey {
        border: 1px solid #eee;
    }

    .detail-right {
        margin-bottom: 30px;
        margin-left: 80px;
    }
    .pro-detail{
      margin-top: 15px;
    }

    .detail-right h3 {
        margin-bottom: 4px;
        font-size: 33px;
        font-family: TimesNewRoman !important;
        font-weight: 400;
        color: #0F6CB6;
        line-height: 54px;
    }

    .detail-right .type-money {
        height: 48px;
        font-size: 28px;
        font-family: TimesNewRoman !important;
        font-weight: 400;
        color: #333336;
        line-height: 48px;
    }

    .img_view {
        width: 100%;
    }

    .type-text {
        margin-top: 20px;
        margin-bottom: 20px;
    }

    .type-text p {
        font-size: 14px !important;
        font-family: TimesNewRoman !important;
        font-weight: 400 !important;
        color: #858585 !important;
        margin-bottom: 12px;
        display: flex;
        align-items: center;
    }

    .type-text p img {
        margin-right: 8px;
    }

    .technicalDetails {
        background: #f5f5f6;
        padding-top: 60px;
        padding-bottom: 60px;
    }

    .item-tit {
        font-size: 28px;
        font-family: Helvetica;
        line-height: 42px;
    }

    .detail-contant {
        /* margin-left: 240px; */
        display: flex;
        justify-content: space-between;
    }

    .table {
        /* width: 1000px; */
        width: 100%;
        background-color: #f5f5f6;
    }

    .table-row {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
    }

    .table-cell {
        flex-direction: column;
        text-align: left;
        width: 33%;
        border-bottom: solid 1px #EEEEF1;
        padding: 15px 0;
    }

    .cell-black {
        font-size: 16px;
        font-family: TimesNewRoman;
        font-weight: 400;
        color: #333336;
        line-height: 24px;
    }

    .list_img_box .list_img {
        cursor: pointer;
        height: 274px;
        width: 100%;
    }

    .cell-gray {
        font-size: 16px;
        font-family: TimesNewRoman !important;
        font-weight: 400;
        color: #99999C;
        line-height: 24px;
    }

    .detailed-bottom {
        /* padding: 80px 480px 80px 480px; */
        background: white;
        padding-bottom: 80px;
    }

    .detailed-description {
        padding-top: 40px;
    }

    .detailed-description-img {
        width: 100%;
        height: auto;
    }

    .documentation {
        background: #f5f5f6;
        padding: 60px 0;
    }

    .documentation-word-center {
        display: flex;
        align-items: center;
        margin-top: 30px;
    }

    .documentation-word-center a {
        text-decoration: none;
        color: #BE6998;
    }

    h2 {
        font-size: 28px;
        font-family: Helvetica;
        color: #333336;
        line-height: 42px;
        font-weight: 400;
    }

    .documentation-word {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }

    .product-recommendations {
        background: white;
        padding-top: 40px;
    }

    .list_box {
        width: 345px;
        margin-bottom: 10px;
        margin-right: 40px;
        border: 1px solid #cccccf;
        background: #f5f5f6;
    }

    .type-title {
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #666669;
        line-height: 24px;
        margin: 0 16px;
        cursor: pointer;
    }

    .type-number {
        font-size: 16px;
        font-family: TimesNewRoman !important;
        font-weight: 400;
        color: #99999C;
        line-height: 24px;
        margin-left: 16px;
    }

    .type-title-else {
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #333336;
        line-height: 24px;
        display: inline-block;
        margin: 0 16px;
    }

    .list_title {
        margin-bottom: 24px;
    }

    .list_title-else {
        margin-bottom: 4px;
    }

    .list_title-bottom {
        display: flex;
        align-items: center;
    }

    .list_title-bottom span {
        display: inline-block;
        width: 40px;
        height: 40px;
        border-radius: 2px;
        border: 1px solid #cccccf;
        margin-left: 16px;
        margin-top: 0;
        text-align: center;
        line-height: 40px;
        background: white;
    }

    .list_title-bottom button {
        background: #0f6cb6;
        border-radius: 2px;
        border: none;
        font-size: 18px;
        font-family: TimesNewRoman !important;
        font-weight: 400;
        color: #ffffff;
        line-height: 40px;
        height: 40px;
        cursor: pointer;
    }

    .list_title-bottom .buy {
        width: 255px;
    }

    .list_title-bottom .add {
        width: 100%;
        margin: 0 16px 16px 16px;
    }

    .recommendations-contant {
        margin-top: 15px;
        flex-wrap: wrap;
        padding-bottom: 75px;
    }

</style>
